_require ['canonical_selector_v4'], ->

  atLeadPage = $('.lead-course-search').length > 0 # this selector is for /busca-cursos

  univSearchUrl = '/simple_universities_search.json'

  universitySelector = $('#interest_universities_ids') #this is used for busca-cursos (interests#intro), home

  # enable inputs
  universitySelector.prop('disabled', false)
  $('#interest_course').prop('disabled', false)

  selected_level = ->
    return $('.switch-level-fields input:checked').val() || ''

  # COURSES
  canonicalSelect = new QB.CanonicalSelectorV4()
  canonicalSelect.init('#interest_course', { level: selected_level, allowClear: true, tags: true })

  $('.js-btn-lead').prop('disabled', false)

  # UNIVERSITIES
  universitySelector.select2
    theme: 'special-university-l'
    allowClear: true
    placeholder: 'Prefere alguma faculdade?'
    minimumInputLength: 3
    maximumInputLength: 80
    ajax:
      url: univSearchUrl
      dataType: 'json'
      delay: 500
      data: (params)->
        return {
          term: params.term,
          per_page: 10,
          page: params.page
        }
      processResults: (data, page)->
        more = (page * 10) < data.total
        return {results: data.items, more: more}
      templateResult: (state) ->
        return state.text

  return false
